import { useEffect } from 'react';
import { Analytics } from '~/services/firebase';

export const useAnalytics = () => {
  useEffect(() => {
    // Inicializa o Analytics quando o componente monta
    if (process.env.NODE_ENV === 'production') {
      Analytics.logEvent('app_open');
    }
  }, []);

  const logPageView = (pageName: string) => {
    if (process.env.NODE_ENV === 'production') {
      Analytics.logEvent('page_view', {
        page_name: pageName,
        page_location: window.location.href,
        page_path: window.location.pathname,
      });
    }
  };

  const logEvent = (eventName: string, parameters?: { [key: string]: any }) => {
    if (process.env.NODE_ENV === 'production') {
      Analytics.logEvent(eventName, parameters);
    }
  };

  const logUserAction = (action: string, category: string, label?: string) => {
    if (process.env.NODE_ENV === 'production') {
      Analytics.logEvent('user_action', {
        action,
        category,
        label,
        timestamp: new Date().toISOString(),
      });
    }
  };

  const logPurchase = (orderId: string, value: number, currency: string = 'BRL') => {
    if (process.env.NODE_ENV === 'production') {
      Analytics.logEvent('purchase', {
        transaction_id: orderId,
        value,
        currency,
        timestamp: new Date().toISOString(),
      });
    }
  };

  const logAddToCart = (itemName: string, itemId: string, price: number) => {
    if (process.env.NODE_ENV === 'production') {
      Analytics.logEvent('add_to_cart', {
        item_name: itemName,
        item_id: itemId,
        price,
        currency: 'BRL',
      });
    }
  };

  const logSearch = (searchTerm: string) => {
    if (process.env.NODE_ENV === 'production') {
      Analytics.logEvent('search', {
        search_term: searchTerm,
      });
    }
  };

  return {
    logPageView,
    logEvent,
    logUserAction,
    logPurchase,
    logAddToCart,
    logSearch,
  };
};
